import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María Soledad García',
    age: 38,
    location: 'Buenos Aires',
    text: 'Mi hijo de 8 años ahora entiende perfectamente el valor del dinero. Ya no pide cosas impulsivamente y hasta empezó a ahorrar para comprarse lo que quiere. ¡Increíble cambio en solo 3 semanas!'
  }, {
    name: 'Roberto Fernández',
    age: 42,
    location: 'Córdoba',
    text: 'Como padre siempre me preocupó no saber cómo enseñarle a mis hijos sobre finanzas. Este programa me dio las herramientas exactas que necesitaba. Mis dos hijas (10 y 13 años) están aprendiendo de forma divertida.'
  }, {
    name: 'Carolina Martínez',
    age: 35,
    location: 'Rosario',
    text: 'Lo mejor es que no necesitas ser experto en finanzas. Todo está explicado de forma simple y práctica. Mi hijo de 6 años ya tiene su sistema de frascos y está súper motivado con sus metas de ahorro.'
  }, {
    name: 'Diego Ramírez',
    age: 40,
    location: 'Mendoza',
    text: 'Invertí en este programa y fue la mejor decisión. Mi hija de 12 años pasó de gastar todo su dinero en golosinas a planificar sus compras y hasta propuso ideas para ganar dinero extra. Estoy sorprendido.'
  }, {
    name: 'Laura Sánchez',
    age: 36,
    location: 'La Plata',
    text: 'Los juegos financieros son geniales. Mis hijos (7 y 9 años) aprenden mientras se divierten. Ya no veo la educación financiera como algo aburrido, y ellos tampoco. 100% recomendado para todos los padres.'
  }];
  return <section className="py-6 px-4 bg-gray-50" data-id="element-309">
      <div className="max-w-4xl mx-auto" data-id="element-310">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-6" data-id="element-311">
          ⭐ LO QUE DICEN LOS PADRES
        </h2>

        <div className="space-y-3" data-id="element-312">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-lg" data-id="element-313">
              <div className="flex mb-2" data-id="element-314">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-315" />)}
              </div>
              <p className="text-lg mb-2 italic" data-id="element-316">"{testimonial.text}"</p>
              <div className="border-t pt-2" data-id="element-317">
                <p className="font-bold text-lg" data-id="element-318">{testimonial.name}</p>
                <p className="text-gray-600" data-id="element-319">
                  {testimonial.age} años • {testimonial.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export default TestimonialsSection;